module.exports = __webpack_public_path__ + "static/media/ZoomOut3.svg";